import clsx from "clsx";
import styles from "./styles.module.scss";

import { ContentProps } from "./types";

export default function Content({ children, className }: ContentProps) {
	return <div className={clsx(styles.container, className)}>{children}</div>;
}
